<template>
  <div class="waitLease-group-dashboard">
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-if="judgePermission('car_to_lease_data_board_tenant_to_deal')"
        label="不可发车辆情况"
        name="1"
      />
      <el-tab-pane
        v-if="judgePermission('car_to_lease_data_board_tenant_to_lease')"
        label="可发车辆情况"
        name="2"
      />
    </el-tabs>

    <component
      v-if="judgePermission(currentComponent.permission)"
      :is="currentComponent.component"
    />
  </div>
</template>
<script>
import UnsentableCars from './unsentableCars.vue'
import SentableCars from './sentableCars.vue'

const TABS = ['1', '2']

export default {
  components: {
    UnsentableCars,
    SentableCars,
  },
  data() {
    const { tab } = this.$route.query
    const activeName = TABS.includes(tab) ? tab : '0'

    return {
      activeName,
      componentMap: {
        [TABS[0]]: {
          component: 'UnsentableCars',
          permission: 'car_to_lease_data_board_tenant_to_deal',
        },
        [TABS[1]]: {
          component: 'SentableCars',
          permission: 'car_to_lease_data_board_tenant_to_lease',
        },
      },
    }
  },
  computed: {
    currentComponent() {
      return this.componentMap[this.activeName]
    },
  },
  methods: {
    handleTabClick(tab) {
      this.activeName = tab.name
    },
  },
  created() {
    const { tab } = this.$route.query
    if (TABS.includes(tab)) return

    if (this.judgePermission('car_to_lease_data_board_tenant_to_deal')) {
      this.activeName = TABS[0]
    } else if (
      this.judgePermission('car_to_lease_data_board_tenant_to_lease')
    ) {
      this.activeName = TABS[1]
    }
  },
}
</script>
<style lang="scss" scoped>
.tabs {
  margin-top: -16px;
}
</style>
